import styled from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #0e0e12;
  gap: 16px;
  color: white;
  border: none;
  min-height: 64px;
  overflow-x: auto;
  width: 100%;
  padding: 0 16px;
  max-width: 1440px;
  position: fixed;
  top: 64px;
  z-index: 30;
  transform: ${({ $hidden }) =>
    $hidden ? "translateY(-64px)" : "translateY(0)"};
  transition: transform 0.35s ease-in-out;
`;

export const NavigationItem = styled.div`
  display: flex;
  gap: 2px;
  height: 3rem;

  a {
    color: #fff;
    font-family: Figtree;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: -0.1px;
    text-decoration-line: none;
    opacity: 0.5;
  }

  a.active {
    font-weight: 600;
    opacity: 1;
  }
`;

export const SoonContainer = styled.div`
  height: 2.5rem;
  padding: 0 12px;
  border-radius: 100px;
  background: #430027;
  color: #fafafa;
  font-family: Figtree;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
